import { render, staticRenderFns } from "./PartnerAssetGroupAccordion.vue?vue&type=template&id=08eaa4ae&"
import script from "./PartnerAssetGroupAccordion.vue?vue&type=script&lang=js&"
export * from "./PartnerAssetGroupAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports